<script>
	import { TableOfContents } from '@skeletonlabs/skeleton';
</script>

<div class="border border-base bg-component p-4 text-surface-50 rounded-container-token">
	<TableOfContents
		active="line-clamp-1 text-primary-500 relative after:absolute after:-left-2 after:top-1/2 after:-translate-y-1/2 after:h-full after:w-1 after:rounded-full after:bg-primary-500"
		inactive="line-clamp-1 text-surface-100"
		regionLead="text-surface-50 font-black"
		regionList="px-2"
	/>
</div>
